import _createForOfIteratorHelper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module table/commands/setheaderrowcommand
 */
import { Command } from 'ckeditor5/src/core.js';
import { updateNumericAttribute } from '../utils/common.js';
import { getVerticallyOverlappingCells, splitHorizontally } from '../utils/structure.js';
/**
 * The header row command.
 *
 * The command is registered by {@link module:table/tableediting~TableEditing} as the `'setTableColumnHeader'` editor command.
 *
 * You can make the row containing the selected cell a [header](https://www.w3.org/TR/html50/tabular-data.html#the-th-element) by executing:
 *
 * ```ts
 * editor.execute( 'setTableRowHeader' );
 * ```
 *
 * **Note:** All preceding rows will also become headers. If the current row is already a header, executing this command
 * will make it a regular row back again (including the following rows).
 */
var SetHeaderRowCommand = /*#__PURE__*/function (_Command) {
  _inherits(SetHeaderRowCommand, _Command);
  var _super = _createSuper(SetHeaderRowCommand);
  function SetHeaderRowCommand() {
    _classCallCheck(this, SetHeaderRowCommand);
    return _super.apply(this, arguments);
  }
  _createClass(SetHeaderRowCommand, [{
    key: "refresh",
    value:
    /**
     * @inheritDoc
     */
    function refresh() {
      var _this = this;
      var tableUtils = this.editor.plugins.get('TableUtils');
      var model = this.editor.model;
      var selectedCells = tableUtils.getSelectionAffectedTableCells(model.document.selection);
      var isInTable = selectedCells.length > 0;
      this.isEnabled = isInTable;
      this.value = isInTable && selectedCells.every(function (cell) {
        return _this._isInHeading(cell, cell.parent.parent);
      });
    }
    /**
     * Executes the command.
     *
     * When the selection is in a non-header row, the command will set the `headingRows` table attribute to cover that row.
     *
     * When the selection is already in a header row, it will set `headingRows` so the heading section will end before that row.
     *
     * @fires execute
     * @param options.forceValue If set, the command will set (`true`) or unset (`false`) the header rows according to
     * the `forceValue` parameter instead of the current model state.
     */
  }, {
    key: "execute",
    value: function execute() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (options.forceValue === this.value) {
        return;
      }
      var tableUtils = this.editor.plugins.get('TableUtils');
      var model = this.editor.model;
      var selectedCells = tableUtils.getSelectionAffectedTableCells(model.document.selection);
      var table = selectedCells[0].findAncestor('table');
      var _tableUtils$getRowInd = tableUtils.getRowIndexes(selectedCells),
        first = _tableUtils$getRowInd.first,
        last = _tableUtils$getRowInd.last;
      var headingRowsToSet = this.value ? first : last + 1;
      var currentHeadingRows = table.getAttribute('headingRows') || 0;
      model.change(function (writer) {
        if (headingRowsToSet) {
          // Changing heading rows requires to check if any of a heading cell is overlapping vertically the table head.
          // Any table cell that has a rowspan attribute > 1 will not exceed the table head so we need to fix it in rows below.
          var startRow = headingRowsToSet > currentHeadingRows ? currentHeadingRows : 0;
          var overlappingCells = getVerticallyOverlappingCells(table, headingRowsToSet, startRow);
          var _iterator = _createForOfIteratorHelper(overlappingCells),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var cell = _step.value.cell;
              splitHorizontally(cell, headingRowsToSet, writer);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        updateNumericAttribute('headingRows', headingRowsToSet, table, writer, 0);
      });
    }
    /**
     * Checks if a table cell is in the heading section.
     */
  }, {
    key: "_isInHeading",
    value: function _isInHeading(tableCell, table) {
      var headingRows = parseInt(table.getAttribute('headingRows') || '0');
      return !!headingRows && tableCell.parent.index < headingRows;
    }
  }]);
  return SetHeaderRowCommand;
}(Command);
export { SetHeaderRowCommand as default };